<template>
  <div class="sezione "  style="padding:0 20px;">

<div v-if="$centro._paziente.length==0" >
<div class="title_h1 yo-color-primary" style="padding-top:30px;">RICHIESTA DI ISCRIZIONE APPROVATA</div>
<br />
Si conferma che la Sua richiesta di adesione al progetto INNSIN è stata accettata e i documenti da Lei caricati sul sito sono stati verificati.
<br />
Può procedere con l'inserimento delle schede pazienti attraverso il menu in alto a destra. 
<br />
Il comitato INNSIN
</div>


<div v-if="isNovita" >
  <div class="yo-text-l yo-text-bold" style="background:#5288C6;color:#fff;margin:32px 0 16px 0;padding:16px 32px;">Novità 2024: disponibile il rapporto 2023</div>
<!--
<div class="title_h1 yo-color-primary" style="padding-top:48px;" >II Webinar INNSIN 26 Ottobre 2021</div>
VALUTAZIONE COMPARATIVA DEGLI ESITI: PROCEDURE DI "RISK-ADJUSTMENT" E MODALITÀ DI RAPPRESENTAZIONE GRAFICA
<br />
<a href="https://www.innsin.it/documenti/Webinar_INNSIN_26Ottobre2021.pdf" target="_blank">scarica il programma </a>

-->


<a href="/documenti/Report2023-20241227.pdf" target="_blank" style="display: block;">Clicca qui&nbsp;per scaricare il rapporto INNSIN 2023</a>
<br /><br />

<a href="/documenti/Report2022-20231016.pdf" target="_blank" style="display: block;">Clicca qui&nbsp;per scaricare il rapporto INNSIN 2022</a>
<br /><br />

<a href="/documenti/Report2021-20221012.pdf" target="_blank" style="display: block;">Clicca qui&nbsp;per scaricare il rapporto INNSIN 2021</a>
<br /><br />


<a href="/documenti/Report2020-20221004.pdf" target="_blank" style="display: block;">Clicca qui&nbsp;per scaricare il rapporto INNSIN 2020</a>
<br /><br />


<a href="/documenti/Report2019.pdf" target="_blank" style="display: block;">Clicca qui&nbsp;per scaricare il rapporto INNSIN 2019</a>
<br /><br />


<!--
<div class="yo-text-l yo-text-bold" style="background:#5288C6;color:#fff;margin:32px 0 16px 0;padding:16px 32px;">NOVITÀ OTTOBRE 2021</div>
<div>
Nella piattaforma INNSIN è stata pubblicata la distribuzione dei centri presenti all’interno del Network secondo i valori di 10 indicatori mediante la rappresentazione grafica del “caterpillar plot”. Il caterpillar plot ordina in modo crescente i centri rispetto al valore espresso dall’indicatore e ne riporta i limiti di confidenza. Il grafico prende il nome di caterpillar plot perché l’effetto visivo che produce la rappresentazione è simile all’aspetto di un “bruco” (con il corpo allungato e molti piedi).
<br /><br />
Per evitare interpretazioni distorte della posizione (ranking) di un centro, le stime puntuali vanno  sempre lette insieme ai rispettivi intervalli di confidenza che indicano la precisione della misura dell’indicatore e quindi informano sulla significatività  statistica delle differenze osservate.
<br /><br />
Si fa presente che in questa prima fase il ranking mostrato nei grafici si basa sul calcolo dell’indicatore basato solo sul dato "grezzo”, che non tiene conto, quindi, dell’effetto di potenziali fattori di confondimento che potrebbero modificare la posizione dei singoli centri. Accanto ai grafici riferiti al 2019, vengono pubblicati quelli riferiti al 2020.  A breve, per i 10 indicatori, sarà pubblicata una versione dei caterpillar plot “aggiustati” per i principali fattori di confondimento.
<br /><br />
<a href="/documenti/Report2020.pdf" target="_blank" style="display: block;">Clicca qui&nbsp;per scaricare il rapporto INNSIN 2020</a>
</div>
-->


<!--
Nel programma di inserimento dati è stata attivata la nuova funzione “REPORT” che permette di produrre statistiche descrittive per alcune variabili presenti nelle sei sezioni della scheda di inserimento dati.
<br /><br />
Cliccando su ANALISI e poi REPORT si entra in una prima maschera che dà la possibilità di stabilire alcune condizioni di “filtro” dei dati, da usare singolarmente (ad esempio se si vogliono analizzare solo i maschi) o in combinazione (ad esempio solo maschi inborn). Per ora, tutte le analisi permetteranno di mettere a confronto, per l’anno 2019 come anno di nascita, le statistiche del proprio centro con quelle dell’intero Network.  Progressivamente, la funzione REPORT permetterà di analizzare anche i dati degli anni successivi e di mettere a confronto i dati del centro con quelli della propria regione o di un’area geografica più ampia. 
<br /><br />
Una volta deciso il filtro da attivare, ma ovviamente si possono lasciare le condizioni di default, è possibile entrare in ciascuna sezione cliccando sulla icona corrispondente in altro a destra. 
<br /><br />
Per alcune variabili continue (ad esempio peso alla nascita in grammi) o discrete (ad esempio punteggio di Apgar a 5 minuti) viene mostrato il valore medio e Deviazione Standard, il valore mediano (corrispondente al 50mo Centile), il primo (Q1) e terzo (Q3) quartile e la differenza fra terzo e primo quartile (Q3-Q1).
<br /><br />
Per ultimo, va segnalato che le variabili in colore blu sono quelle compilabili solo per i neonati con Età Gestazionale &#60;= 31 settimane o Peso alla Nascita &#60;=1500 grammi, pertanto il numero di casi contati rappresenta un sottoinsieme di quelli analizzati per il resto delle variabili presenti.
<br /><br />
-->

<!--
<div class="yo-text-l yo-text-bold" style="background:#5288C6;color:#fff;margin:32px 0 16px 0;padding:16px 32px;">NOVITÀ LUGLIO 2021</div>

<div style="margin:32px 0;">
Nella piattaforma INNSIN è stata pubblicata la distribuzione dei centri presenti all’interno del Network secondo i valori di 11 indicatori mediante la rappresentazione grafica del “caterpillar plot”. Il caterpillar plot ordina in modo crescente i centri rispetto al valore espresso dall’indicatore e ne riporta i limiti di confidenza. Il grafico prende il nome di caterpillar plot perché l’effetto visivo che produce la rappresentazione è simile all’aspetto di un “bruco” (con il corpo allungato e molti piedi).
<br /><br />
Per evitare interpretazioni distorte del ranking di un centro, le stime puntuali andranno sempre lette insieme ai rispettivi intervalli di confidenza che danno una migliore informativa sulla precisione della misura dell’indicatore e sulle differenze statisticamente significative.
<br /><br />
Si fa presente che in questa prima fase il ranking mostrato nei grafici si basa sul calcolo dell’indicatore basato solo sul dato "grezzo”, che non tiene conto, quindi, di potenziali fattori di confondimento che potrebbero modificare la posizione dei singoli centri. A breve, con i dati consolidati del 2020 e per gli stessi indicatori, sarà pubblicata anche un versione dei caterpillar plot “aggiustati” per tenere “sotto controllo” i principali fattori di confondimento.
 
</div>


-->




<div class="yo-align-right" style="margin:32px;">
<el-button type="primary" icon="el-icon-error" v-on:click="isNovita=false" >Chiudi</el-button>
</div>

</div>

<pazienteCerca  v-if="!isNovita && $centro._paziente.length>0"></pazienteCerca>

<!--
  <el-collapse >
      
    <el-collapse-item name="schedeinlavorazione" v-if="this.$centro._schedeinlavorazione.length>0">
      <template slot="title">
        <div class="row">
          <div class="col s8">Schede in lavorazione</div>
           <div class="col s3m yo-align-right" v-if="this.$socio._assicurazione.length>0">ultimo effettuato il {{$socio._assicurazione[0].vrsdata | data()}} di {{$socio._assicurazione[0].vrsimporto | money('€ ')}}</div>
        </div>
      </template>

      <schedeInlavorazione></schedeInlavorazione>

    </el-collapse-item>
      
    <el-collapse-item name="schedechiuse" v-if="this.$centro._schedechiuse.length>0">
      <template slot="title">
        <div class="row">
          <div class="col s8">Schede chiuse</div>
           <div class="col s3m yo-align-right" v-if="this.$socio._assicurazione.length>0">ultimo effettuato il {{$socio._assicurazione[0].vrsdata | data()}} di {{$socio._assicurazione[0].vrsimporto | money('€ ')}}</div> 
        </div>
      </template>

      <schedeChiuse></schedeChiuse>

    </el-collapse-item>


  </el-collapse>

-->


  </div>
</template>

<script>
import pazienteCerca from './Paziente-cerca.vue'
//import schedeInlavorazione from './Schede-inlavorazione.vue'
//import schedeChiusa from './Schede-chiusa.vue'
export default {
  components: {
    pazienteCerca
    //schedeInlavorazione
    //,schedeChiusa
  },
  data() {
   return {
      isNovita: true
   }
  },
  created () {

    setTimeout(() => {
      this.isNovita = false
    }, 30000);
    /* POPUP ELIMINATO A FINE AGOSTO 2020*/
    /* POPUP RIPRISTINATO A MAGGIO 2021*/
    /* POPUP ELIMINATO A GNO 2021
    if(!this.$centro.letto){
      this.$centro.letto = true
      this.$alert('La deadline per l\'inserimento delle schede dei pazienti 2020 è spostata al <strong>1 giugno 2021</strong>', 'Comunicazione Importante', {
        confirmButtonText: 'Ok ho letto',
        dangerouslyUseHTMLString: true,
        callback: action => {
          this.$message({
            type: 'info',
            message: `Hai letto la deadline inserimento schede pazienti anno 2020`
          })
        }
      })
    }
    */
  }
}
</script>


<style scoped>
  .home{
    background:#fff;
    min-height:600px;
    padding:20px;
  }
</style>
